export enum FetalSituation {
	Longitudinal = "0",
	Transversal = "1",
}
